<template>
<div class="song-list">    
    <div class="col-xs-12 search-input">
        <input type="text" class="browser-default" placeholder="Search artist, title ..." v-model="searchText">
        <span v-show="!searchText.length">
            <i class="iconify icon:ic:outline-search"></i>
        </span>
        <span v-show="searchText.length" @click="cancelSearch">
            <i class="iconify icon:mdi:close-circle"></i>
        </span>   
    </div>

    <div class="text-center" v-show="loading">
        <loader size="128px"></loader>
    </div>

    <div v-if="!loading && !song.hide" v-for="(song,i) in songs" @click="selectSong(song)" class="button song" :class="{ 'active': isSelected }">
        <div class="image" @click="play()">
            <div :data-img="getSongImage(song)" class="lazzyLoad"></div>
        </div>
        <div class="artist">{{ song.artist }}</div>
        <div class="title">{{ song.title }}</div>
        <div v-if="song.unread > 0" class="unread">{{ song.unread }}</div>
    </div>    
</div>
</template>

<script>
export default {
    components: {
        'loader': require('@/components/Loader.vue').default,
    },

    props: ['owner'],


    data() {
        return {
            songs: [],
            loading: true,
            searchText: ''
        }
    },

    activated(){
        LazzyLoad();
    },

    mounted(){
        this.getSongs();
        this.$root.$on('messages-badges', this.getMessagesBadges);
        this.$root.$on('update-song-message-badge', this.updateSongMessageBadge);
    },

    methods: {
        getSongs() {
            // this.songs = [];
            this.$http.get(this.getSongsEndpoint).then((success) => {
                this.songs = success.data.data;
                this.loading = false;

                this.$nextTick(() => {
                    LazzyLoad();
                });
            });
        },

        getMessagesBadges(params){
            if (params.action == 'set'){
                this.getSongs();
            }
        },

        updateSongMessageBadge(id, value){
            $.each(this.songs, (i, song) => {
                if (song.id == id){
                    song.unread = value ? song.unread + value : 0;
                }
            })
        },

        selectSong(song){
            setTimeout(() => {
                this.$parent.$emit('song-select', song);    
            }, 300);            
        },

        getSongImage(song){
            return App.restApi + '/api/image/' + song.image;
        },

        cancelSearch(){
            $('.search-input').blur();
            this.searchText = '';
        },

        play(song){
            // this.$root.$emit('mp-load-song', song, false);
        }
    },

    computed: {
        isSelected() {
            return false; //this.selectedSong == this.song.id;
        },

        getSongEndpoint() {
            return App.restApi + '/api/song/' + this.song.id;
        },

        getSongsEndpoint() {
            var endpoint = App.restApi + '/api/v2/conversations/songs?song_owner=' + this.owner;
            return endpoint;
        },
    },

    watch: {
        searchText(){
            $.each(this.songs, (i, s) => {
                var hide =  s.title.toLowerCase().indexOf(this.searchText.toLowerCase()) == -1 &&  s.artist.toLowerCase().indexOf(this.searchText.toLowerCase()) == -1;
                s.hide = this.searchText.length ? hide : false;
            })

            this.$nextTick(() => {
                LazzyLoad();
            });            
        }
    },

    beforeDestroy() {
        this.$root.$off('messages-badges', this.getMessagesBadges);
        this.$root.$off('update-song-message-badge', this.updateSongMessageBadge);
    }     
}
</script>
